export const INPATIENT = 'IP';
export const EMERGENCY = 'ER';
export const OUTPATIENT = 'OP';

export const INPATIENT_CLASS_UID = 114100;
export const OUTPATIENT_CLASS_UID = 114101;